import React from 'react';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from 'react-simple-maps';

/**
 * Geographic map renderer using react-simple-maps
 * Displays world map with markers for locations
 */
export function MapRenderer({ data }) {
  const { markers = [], center = [0, 20], zoom = 1, highlight = [] } = data;

  // Use Natural Earth low-resolution map data
  const geoUrl =
    'https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json';

  return (
    <div className="map-container w-full max-w-4xl mx-auto">
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{
          scale: 147,
        }}
        style={{
          width: '100%',
          height: 'auto',
        }}
      >
        <ZoomableGroup center={center} zoom={zoom}>
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => {
                const isHighlighted = highlight.includes(geo.properties.name);
                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={isHighlighted ? '#3b82f6' : '#e5e7eb'}
                    stroke="#9ca3af"
                    strokeWidth={0.5}
                    style={{
                      default: { outline: 'none' },
                      hover: {
                        fill: isHighlighted ? '#2563eb' : '#d1d5db',
                        outline: 'none',
                      },
                      pressed: { outline: 'none' },
                    }}
                  />
                );
              })
            }
          </Geographies>

          {markers.map((marker, index) => (
            <Marker key={index} coordinates={marker.coords}>
              <g>
                <circle r={6} fill="#ef4444" stroke="#fff" strokeWidth={2} />
                <text
                  textAnchor="middle"
                  y={-12}
                  style={{
                    fontFamily: 'system-ui',
                    fontSize: '12px',
                    fill: '#374151',
                    fontWeight: 'bold',
                  }}
                >
                  {marker.label}
                </text>
              </g>
            </Marker>
          ))}
        </ZoomableGroup>
      </ComposableMap>

      {markers.length > 0 && (
        <div className="mt-4 text-sm text-gray-600 dark:text-gray-400">
          <strong>Locations:</strong> {markers.map((m) => m.label).join(', ')}
        </div>
      )}
    </div>
  );
}
